import type { DisplayedArtifact } from "@/lib/migrations/apply";
import type { EngineArtifactRecord } from "@/services/migrations/engine";

/**
 * What one task card is currently showing, reported up to the plan-level approval gate.
 *
 * This exists because the two facts live in different places: the artifact a reviewer has
 * open is per-task local state, and the approval that must be bound to it is a single
 * plan-wide decision covering every task at the gate. Without lifting this, the gate
 * would have no way to know whether the person about to bulk-approve four tasks had read
 * any of them — and "approved without reading" is indistinguishable, in the ledger and to
 * the write path, from a considered approval.
 *
 * `loaded: false` is the initial value on purpose. A task that has not reported in is
 * treated exactly like one whose artifacts failed to load: not reviewed.
 */
export interface TaskReviewState {
  loaded: boolean;
  artifacts: EngineArtifactRecord[];
  displayed: DisplayedArtifact | null;
}

export const EMPTY_REVIEW_STATE: TaskReviewState = {
  loaded: false,
  artifacts: [],
  displayed: null,
};
